import React, { useEffect, useState } from 'react'
import Select from "react-select";
import MessageHeading from '../../components/CommonComponents/MessageHeading'
import Defaultloadinggif from '../../layout/Others/Defaultloadinggif'
import { useMyContext } from '../../components/Provider/CommonProvider'
import MessageSubHeading from '../../components/CommonComponents/MessageSubHeading'
import MessageLabel from '../../components/CommonComponents/MessageLabel'
import MessageBox from '../../components/CommonComponents/MessageBox'
import AdminCustomButton from '../../components/CommonComponents/AdminCustomButton'
import { toast } from 'react-toastify';

const BunnyStorage = () => {
    const baseURL = process.env.REACT_APP_Baseurl
    const bunnyFolders = `${baseURL}/admin/bunny-cdn-video-library`
    const uploadApi = `${baseURL}/admin/bunny-cdn-video-upload-library`
    const libraryFind = `${baseURL}/admin/bunny-cdn-stream-video-library`
    const bunnyCdnMoveToSiteStorage = `${baseURL}/admin/bunny-cdn-stream-video-update-library`
    const { handleFileChangeProvider, fetchRequest } = useMyContext()

    const [state, setState] = useState({
        folderPage: 1,
        folderLimit: 10,
        folderTotalCount: 0,
        folderLoading: true,
        folders: [],
        folderError: "",
        folderActive: null,
        upload_type: "video",
        folderVideos: [],
        withOutRefresh: true,
        cdn_url: []
    })


    function formatFileSize(bytes) {
        const gb = bytes / 1_000_000_000;
        const mb = bytes / 1_000_000;
        if (gb >= 1) {
            return `${gb.toFixed(2)} GB`;
        } else if (mb >= 1) {
            return `${mb.toFixed(2)} MB`;
        } else {
            return `${(bytes / 1000).toFixed(2)} KB`;
        }
    }

    const formatOptionLabel = ({ value, label, url, library_id }) => (
        <div>
            <span style={{ marginLeft: '5px', fontSize: "13px" }} className='opacity-75'>{library_id}</span>
            <span>-</span>
            <span>{label}</span>
        </div>
    );

    const libraryChange = async (id) => {
        setState((prev) => ({
            ...prev,
            folderActive: id,
        }))
    }

    const handleTypeChange = (val) => {
        setState((prev) => ({
            ...prev,
            upload_type: val
        }))
    }
    const handleMultiSelect = (selectedOptions, actionMeta) => {
        setState((prev) => ({
            ...prev,
            [actionMeta.name]: selectedOptions
        }))
    }

    const multiSelectLabel = (array, valueKey, labelKey, url, library_id, resolutions, duration) => {
        return Array.isArray(array) ? array?.map((item) => ({
            value: item[valueKey],
            label: item[labelKey],
            url: item[url],
            library_id: item[library_id],
            resolutions: item[resolutions],
            length: item[duration]
        })) : [];
    };

    const fetchBunnyFolders = async () => {
        try {
            setState((prev) => ({ ...prev, folderLoading: true }))
            const responseBunnyLibrary = await fetchRequest({
                method: 'GET',
                url: `${bunnyFolders}`,
                params: {},
                data: {},
            })
            if (responseBunnyLibrary?.status) {
                const result = responseBunnyLibrary?.Items
                setState((prev) => ({
                    ...prev,
                    folderActive: result?.[0]?.Id,
                    folders: result
                }))
            }
        }
        catch (error) {
            setState((prev) => ({
                ...prev,
                folderError: error?.response?.data?.error || error?.response?.data?.message || error.message || error || "Something wrong"
            }))
        }
        finally {
            setState((prev) => ({ ...prev, folderLoading: false }))
        }
    }

    const fetchFolderVideos = async () => {
        const response = await fetchRequest({
            method: 'POST',
            url: `${libraryFind}`,
            params: {},
            data: {
                videolibrary_id: state?.folderActive
            },
        }).then((response) => {
            if (response?.status) {
                setState((prev) => ({
                    ...prev,
                    folderVideos: multiSelectLabel(response?.streamvideos?.items, 'guid', 'title', 'videoUrl', 'videoLibraryId', 'availableResolutions', 'length')
                }))
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
        })
    }
    const bunnyCdnUrlMoveToSiteLibrary = async () => {
        if (!state?.cdn_url?.length) {
            toast.info("Please select videos")
            return
        }
        setState((prev) => ({ ...prev, cdnMoveLoader: true }))
        const updatedList = state?.cdn_url?.map((item) => {
            return {
                title: item?.value + item?.label,
                m3u8_url: item?.url,
                resolutions: item?.resolutions,
                duration: item?.length
            } || []
        })
        const response = await fetchRequest({
            method: 'POST',
            url: `${bunnyCdnMoveToSiteStorage}`,
            params: {},
            data: {
                videos: updatedList,
                upload_source_type: 404,
                source_type: 1
            },
        }).then((response) => {
            if (response?.status) {
                toast.success(response.message)
                setState((prev) => ({ ...prev, withOutRefresh: !prev }))
            }
        }).catch((err) => {
            toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
        }).finally(() => {
            setState((prev) => ({ ...prev, cdnMoveLoader: false }))
        })
    }

    useEffect(async () => {
        await fetchBunnyFolders()
    }, [])

    useEffect(async () => {
        if (state?.upload_type === "m3u8_url") {
            await fetchFolderVideos()
        }
    }, [state?.upload_type])

    return (
        <>
            {state?.folderLoading ? <Defaultloadinggif /> : state?.folderError ? state?.folderError :
                <div className={`theme-bg-color p-4 rounded-3`}>
                    <MessageHeading text={`Bunny Stream Folders`} padding border />
                    <div className='d-flex align-items-center flex-wrap gap-4 mb-3'>
                        {state?.folders?.map((item, index) => (
                            <div className='col-3' onClick={() => libraryChange(item?.Id)} id="bunnyCdnFolder">
                                <div className={`${state?.folderActive == item?.Id ? 'theme-button-bg-color' : 'theme-bg-color-secondary'}  p-3 rounded-3`}>
                                    <MessageLabel text={item?.Name} noMargin className={`mb-2 ${state?.folderActive == item?.Id ? 'theme-button-text-color' : ''}`} />
                                    <MessageSubHeading text={`${item?.VideoCount} Videos`} loadingHide className={`mb-4 ${state?.folderActive == item?.Id ? 'theme-button-text-color' : ''}`} />
                                    <div className='d-flex align-items-center justify-content-between'>
                                        <div>
                                            <MessageLabel text={`Storage `} noMargin className={`mb-2 ${state?.folderActive == item?.Id ? 'theme-button-text-color' : ''}`} />
                                            <MessageSubHeading text={formatFileSize(item?.StorageUsage)} className={`mb-4 ${state?.folderActive == item?.Id ? 'theme-button-text-color' : ''}`} />
                                        </div>
                                        <div>
                                            <MessageLabel text={"Traffic"} noMargin className={`${state?.folderActive == item?.Id ? 'theme-button-text-color' : ''} mb-2`} />
                                            <MessageSubHeading text={formatFileSize(item?.TrafficUsage)} className={`${state?.folderActive == item?.Id ? 'theme-button-text-color' : ''} mb-4`} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <MessageHeading text={`Upload to Bunny Stream`} padding border />

                    <div className='d-flex flex-wrap mb-3 align-items-center justify-content-start gap-3 '>
                        <button
                            id="videoButton"
                            className={` ${state?.upload_type === 'video' ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-3 py-3 px-5`}
                            onClick={() => handleTypeChange('video')}
                        > Upload Video to Bunny CDN</button>
                        <button
                            id="m3u8Button"
                            className={` ${state?.upload_type === "m3u8_url" ? "theme-button-text-color" : "theme-border-color-primary border-1 border-solid theme-text-color theme-bg-color-secondary"} rounded-3 py-3 px-5`}
                            onClick={() => handleTypeChange('m3u8_url')}
                        > Bunny CDN URL to move Site storage</button>
                    </div>

                    {state?.upload_type == "video" ? <div className="customDropWrapper rounded-4 theme-bg-color-secondary">
                        <div className="dropZoneText d-flex align-items-center justify-content-center">
                            <MessageBox text={`Drag and drop ${(state?.upload_type === 'video' || state?.upload_type === 'trailer' || state?.upload_type === 'substitute') ? "video" : "audio"} files here, or click to select files`} classname="theme-text-color" />
                        </div>
                        <input
                            type="file"
                            id="fileInput"
                            accept={(state?.upload_type === 'video' ? "video/mp4" : '')}
                            className="w-100 h-100"
                            multiple
                            onChange={(e) => handleFileChangeProvider(e, `${uploadApi}`, "library", { libraryId: state?.folderActive, })}
                        />
                    </div> : ""}

                    {state?.upload_type == "m3u8_url" ?
                        <>
                            <MessageLabel text={`Library ${state?.folderActive}`} />
                            <Select id="moveURLId" formatOptionLabel={formatOptionLabel} isMulti closeMenuOnSelect={false} options={state?.folderVideos} name={'cdn_url'} onChange={handleMultiSelect} value={state?.cdn_url} className="custom-select-multi custom-placeholder theme-text-color mb-3" />
                            <AdminCustomButton id="urlMoveProceedButton" saveMethod={bunnyCdnUrlMoveToSiteLibrary} saveText="Move to Site Library" loading={state?.moveloading} className={"d-flex justify-content-end ms-auto mt-5"} />
                        </>

                        : ""}
                </div>}
        </>
    )
}

export default BunnyStorage